module.exports = __webpack_public_path__ + "images/Suso_Logo.svg";